import { GET_CUSTOMERS, ADD_CUSTOMER, UPDATE_CUSTOMER } from 'redux/actionTypes';

export default function customers(state = [], action) {
    switch(action.type) {
        case GET_CUSTOMERS:
            return [
                ...state,
                ...action.payload
            ];
        case ADD_CUSTOMER:
            return [
                action.payload,
                ...state
            ];
        case UPDATE_CUSTOMER:
            const index = state.findIndex(customer => customer.id === action.payload.id);
            return [
                ...state.slice(0, index),
                action.payload,
                ...state.slice(index + 1)
            ];
        default:
            return state;
    }
};